import PropTypes from 'prop-types';

import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import { ModifyIconedLink, DeleteIconedLink } from '@/components/common/iconedLinks';

const Commands = ({ t, editMode, onSaveModification, onCancelModification, onModifyMessage, onDeleteMessage }) => (
  <div className="editor-commands" data-test-id="commands-container">
    {editMode ? (
      <>
        <CallToActionContainer id="save" onClick={onSaveModification} data-rbf="gift-message-update">
          {t('btn.validate')}
        </CallToActionContainer>
        <CallToActionContainer
          id="cancel"
          kind={CallToActionKind.SECONDARY}
          onClick={onCancelModification}
          data-rbf="gift-message-delete"
        >
          {t('btn.cancel')}
        </CallToActionContainer>
      </>
    ) : (
      <>
        <ModifyIconedLink onEdit={onModifyMessage} rbf="link-message-update" />
        <DeleteIconedLink onDelete={onDeleteMessage} rbf="link-message-delete" />
      </>
    )}
  </div>
);

Commands.propTypes = {
  t: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
  onSaveModification: PropTypes.func.isRequired,
  onCancelModification: PropTypes.func.isRequired,
  onModifyMessage: PropTypes.func.isRequired,
  onDeleteMessage: PropTypes.func.isRequired
};

export default Commands;
